import { createColumnHelper } from '@tanstack/react-table';

import { ConfigMapRowData } from '../types';

export const columnHelper = createColumnHelper<ConfigMapRowData>();
